import Vue from "vue";
import App from "./App.vue";
import i18n from "@/internationalization/i18n";
import Vue2TouchEvents from "vue2-touch-events";
import router from "./router/router";
const { getAppTranslation } = require('./actions/onloadActions');

Vue.use(Vue2TouchEvents, {
  tapTolerance: 5,
  touchHoldTolerance: 400,
  swipeTolerance: 60,
  longTapTimeInterval: 400,
});

Vue.config.productionTip = false;

// Create reactive data store
const store = Vue.observable({
  // ======= States =======
  user: {
    email: "", // User email
    confirmedEmail: false, // Status of user's email (his email is confirmed or not)
    firstName: "",
    lastName: "",
    country_code: "en",
    token: null,
    zohoId: "",
    moduleType: "",
    newsLink: "", // Link to the newsletter page on Fit20 website depending on the country of the user
    studiosInfo: [], // Array of all studios of the user
    profileImgUrl: require("@/assets/imgs/placeholder_user_img.png"),
    progressData: false,
    mobileId: null,
  },
  // appLangsArr: [
  //   {
  //     countryCode: 'de',
  //     language: "de"
  //   },
  //   {
  //     countryCode: 'en',
  //     language: "en"
  //   },
  //   {
  //     countryCode: 'es',
  //     language: "es"
  //   },
  //   {
  //     countryCode: 'fr',
  //     language: "fr"
  //   },
  //   {
  //     countryCode: 'nl',
  //     language: "nl"
  //   },
  //   {
  //     countryCode: 'se',
  //     language: "se"
  //   },
  //   {
  //     countryCode: 'ar',
  //     language: "ar"
  //   },
  // ],
  appLangsArr: [
    {
      countryCode: 'de',
      language: "Deutsch",
    },
    {
      countryCode: 'en',
      language: "English",
    },
    {
      countryCode: 'es',
      language: "Español",
    },
    {
      countryCode: 'fr',
      language: "Français"
    },
    {
      countryCode: 'nl',
      language: "Nederlands",
    },
    {
      countryCode: 'se',
      language: "Svenska",
    },
    {
      countryCode: 'ar',
      language: "العربية",
    },
  ],
  loadedApp: false,
  selectedAppLanguage: "en",
  selectedAppLanguageIndex: 1,
  appLanguageChangedBeforeLogin: false,
  allLanguages: false,
  homePageCards: false,
  sessionToken: "", // Toke of the current session (after login)
  requestSource: null, // Source of the request to the app (web browser / mobile app)
  registrationCompleted: false,
  registerViaInvitationLink: false, // User register via an invitation link
  confirmingAccount: false,
  unconfirmedAccount: false,
  selectCountryPage: false, // User navigate to select country page
  showFooterBackBtn: true,
  showChangeUserImgPage: false,
  reloadHeaderApp: 0,
  // showHomePageSearchBar: false,
  showStudiosOptionsPage: false,
  showMainErrorPage: false, // Main error page for a general error that does not allow the page to load
  showErrorPopup: false,
  errorPopupTitle: "",
  errorPopupMsg: "",
  mustLogOut: false, // If the user is not authenticated or its toke is invalid or expired.
  tempMobileLogin: false,
  activeNavBarButton: "home",
  planning: false,
  flutterAppMustBeUpdated: false,
  // =======================
  
  // ======= Methods =======
  resetStoreUser() {
    store.user = {
      email: "",
      confirmedEmail: false,
      firstName: "",
      lastName: "",
      country_code: "en",
      token: null,
      zohoId: "",
      moduleType: "",
      newsLink: "",
      studiosInfo: [],
      profileImgUrl: require("@/assets/imgs/placeholder_user_img.png"),
    };
  },
  async authUser(email, token) {
    try {
      const authUserResponse = await fetch(`/api/user/auth/${email}/${token}`);
      const authUserResponseJson = await authUserResponse.json();
      if (!authUserResponseJson.status) {
        if (authUserResponseJson.confirmWarning) {
          return {
            status: false,
            confirmWarning: true,
          };
        } else {
          if (authUserResponseJson.error) {
            return {
              status: false,
              error: true,
            };
          } else {
            return false;
          }
        }
      }

      // console.log(authUserResponseJson);

      const user = authUserResponseJson.user;
      // console.log(user);

      store.user.email = email;
      store.user.confirmedEmail = user.confirmInfo.status;
      store.user.token = token;
      store.user.firstName = user.firstName;
      store.user.lastName = user.lastName;
      store.user.country_code = authUserResponseJson.studiosInfo[0].country_code;
      store.user.zohoId = user.zohoId;
      store.user.moduleType = user.moduleType;
      store.user.newsLink = authUserResponseJson.newsLink;
      store.user.studiosInfo = authUserResponseJson.studiosInfo;
      store.user.type = user.type;
      store.changeAppLanguage(user.appLanguage);
      store.planning = authUserResponseJson.planning;

      const url = `https://storage.googleapis.com/fit20_client_app/imgs/clients_profile_photos/${store.user.zohoId}.png`;
      const profileImgExist = await store.checkOnlineImageExist(url);
      if (profileImgExist) {
        store.user.profileImgUrl = url;
      } else {
        store.user.profileImgUrl = require("@/assets/imgs/placeholder_user_img.png");
      }
      // console.log("store.selectedAppLanguage: " + store.selectedAppLanguage);
      return {
        status: true,
      };
    } catch (err) {
      return {
        status: false,
        error: true,
      };
    }
  },
  setCookie(name, value, daysToExpire) {
    const date = new Date();
    date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  },
  getCookie(name) {
    const cookieName = name + "=";
    const cookies = decodeURIComponent(document.cookie).split(";");
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    return false;
  },
  deleteCookie(name) {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
  },
  setLocalStorage(name, data) {
    localStorage.setItem(name, JSON.stringify(data));
  },
  getLocalStorage(name) {
    return JSON.parse(localStorage.getItem(name));
  },
  deleteLocalStorage(name) {
    localStorage.removeItem(name);
  },
  async logOut() {
    try {
      if (store.requestSource.includes("webView")) {
        // console.log("App has opened from Mobile...");
        // console.log("store.user.mobileId: " + store.user.mobileId);
        // console.log("store.requestSource: " + store.requestSource);
        // console.log("store.user.email: " + store.user.email);
        // console.log("store.user.token: " + store.user.token);
        if (store.user.mobileId) {
          // console.log("Deleting mobile id...");
          // console.log("store.user.mobileId: " + store.user.mobileId);
          // console.log("store.requestSource: " + store.requestSource);
          // console.log("store.user.email: " + store.user.email);
          // console.log("store.user.token: " + store.user.token);

          const dataObj = {
            email: store.user.email,
            token: store.user.token,
            mobileId: store.user.mobileId,
          };

          await fetch('/api/user/deleteMobileId', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=UTF-8',
            },
            body: JSON.stringify(dataObj),
          });
        }
        store.tempMobileLogin = false;
        try {
          if (window.flutter_webView_remove_cached_user) {
            await window.flutter_webView_remove_cached_user.postMessage("true");
          }
        } catch (flutterErr) {
          console.warn("Flutter bridge not available:", flutterErr);
        }
      }
      localStorage.removeItem("user");
      store.resetStoreUser();
    }
    catch(err) {
      console.error(err);
    }
  },
  async openExternalUrl(url) {
    if (store.requestSource.includes("webView")) {
      try {
        await window.flutter_webView_open_external_url.postMessage(
          JSON.stringify({ url: url })
        );
      } catch (err) {
        console.log("Error in sending url to webview");
        console.log(err);
        store.errorPopupTitle = 'unfortunately';
        store.errorPopupMsg = 'something_went_wrong_try_again';
        store.showErrorPopup = true;
      }
    } else {
      // window.location.href = url;
      // console.log("url from openExternalUrl: " + url);
      window.open(url, "_blank");
    }
  },
  /* === Validate email === */
  EmailValidation(email) {
    if (email) {
      // Regular expression for a simple email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      // Test the email against the regular expression
      return emailRegex.test(email);
    }
    return false;
  },
  backToLoginPage() {
    store.showFooterBackBtn = true;
    store.selectCountryPage = false;
    store.unconfirmedAccount = false;
    store.registrationCompleted = false;
    store.confirmingAccount = false;
    router.push("/login");
  },
  checkOnlineImageExist(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;

      if (img.complete) {
        resolve(true);
      } else {
        img.onload = () => {
          resolve(true);
        };

        img.onerror = () => {
          resolve(false);
        };
      }
    });
  },
  async changeAppLanguage(lang) {
    // console.log("Change App language function...");
    // console.log("lang: " + lang);
    // console.log("store.selectedAppLanguage: " + store.selectedAppLanguage);

    if (lang.toLowerCase() !== store.selectedAppLanguage) {
      // console.log("store.allLanguages...");
      // console.log(store.allLanguages);
      if (!store.allLanguages) {
        try {
          const translationResponse = await getAppTranslation();
          if (translationResponse.status) {
              store.allLanguages = translationResponse.data;
          }
          else {
              store.allLanguages = i18n.messages;
          }
        }
        catch(e) {
          console.log("Error getting translation");
          console.log(e);
          store.allLanguages = i18n.messages;
        }
      }

      if (store.allLanguages) {
        let selectedLanguageObj;

        Object.keys(store.appLangsArr).some(key => {
          if (store.appLangsArr[key]['countryCode'] == lang) {
            selectedLanguageObj = store.appLangsArr[key];
            store.selectedAppLanguage = selectedLanguageObj.countryCode;
            store.selectedAppLanguageIndex = key;
            i18n.locale = selectedLanguageObj.countryCode;
            i18n.setLocaleMessage(
              i18n.locale,
              store.allLanguages[i18n.locale]
            );
            return true; // This will stop the loop after the first match
          }
          return false; // Continue looping if no match is found
        });
      }
    }
    // console.log("changeAppLanguage:" + store.appLanguageChangedBeforeLogin);
    // console.log("store.requestSource:" + store.requestSource);
    if (store.requestSource && store.requestSource.includes("webView")) {
      try {
        if (window.flutter_change_app_language) {
          await window.flutter_change_app_language.postMessage(JSON.stringify({appLang: store.selectedAppLanguage}));
        }
      } catch (err) {
        console.warn("Error calling Flutter language change:", err);
      }
    }
  },



  // changeAppLanguage(lang) {
  //   console.log("Change App language function...");
  //   console.log("lang: " + lang);
  //   console.log("store.selectedAppLanguage: " + store.selectedAppLanguage);

  //   const current = (store.selectedAppLanguage || 'en').toString().trim().toLowerCase();
  //   const target = (lang || current).toString().trim().toLowerCase();

  //   if (current !== target) {
  //     if (store.allLanguages && Array.isArray(store.appLangsArr)) {
  //       let selectedLanguageObj;

  //       Object.keys(store.appLangsArr).some(key => {
  //         const entry = store.appLangsArr[key];
  //         if (entry && (entry.countryCode || '').toLowerCase() === target) {
  //           selectedLanguageObj = entry;
  //           return true;
  //         }
  //         return false;
  //       });

  //       if (selectedLanguageObj) {
  //         store.selectedAppLanguage = selectedLanguageObj.countryCode.toLowerCase();
  //         store.selectedAppLanguageIndex = Number.isNaN(parseInt(selectedLanguageObj.index)) ? Number(Object.keys(store.appLangsArr).find((k) => store.appLangsArr[k] === selectedLanguageObj)) : parseInt(selectedLanguageObj.index);
  //         i18n.locale = store.selectedAppLanguage;
  //         if (store.allLanguages[i18n.locale]) {
  //           i18n.setLocaleMessage(i18n.locale, store.allLanguages[i18n.locale]);
  //         }
  //         return;
  //       }
  //     }

  //     store.selectedAppLanguage = target;
  //     i18n.locale = target;
  //   }
  // },
});

// Prepare a promise that resolves once translations are loaded in App.vue
store.translationsReadyPromise = new Promise((resolve) => {
  store._resolveTranslationsReady = resolve;
});

// Make the store global
Vue.prototype.$store = store;

new Vue({
  i18n,
  router,
  render: (h) => h(App),
}).$mount("#app");

export default store;
